import { effect, inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { FiscalCalendarResponseDTO } from '@libs/api';
import { FiscalCalendarQueriesService } from '@portal/app/shared/services/queries/fiscal-calendar-queries.service';
import { FiscalDatePresetService } from '@portal/app/shared/services/fiscal-date-preset.service';

@Injectable({ providedIn: 'root' })
export class FiscalCalendarStateService {
  private readonly fiscalCalendarQueries = inject(FiscalCalendarQueriesService);
  private readonly fiscalDatePresetService = inject(FiscalDatePresetService);
  readonly fiscalCalendarQuery = injectQuery(() =>
    this.fiscalCalendarQueries.fiscalCalendar()
  );

  readonly ready$ = new BehaviorSubject<boolean>(false);

  constructor() {
    effect(() => {
      if (this.fiscalCalendarQuery.isSuccess()) {
        const data = this.fiscalCalendarQuery.data();
        if (data) {
          this.fiscalDatePresetService.setCalendarData({
            months: data.months,
            quarters: data.quarters,
            years: data.years
          });
        }
        this.onFiscalCalendarQuerySuccess();
      }
    });
  }

  onFiscalCalendarQuerySuccess(): void {
    if (!this.ready$.value) {
      this.ready$.next(true);
    }
  }

  isCustomCalendarEnabled(): boolean {
    return this.fiscalCalendarQuery.data()?.isCustomCalendar === true;
  }

  fiscalCalendarData(): FiscalCalendarResponseDTO | undefined {
    return this.fiscalCalendarQuery.isSuccess()
      ? this.fiscalCalendarQuery.data()
      : undefined;
  }
}
